// extracted by mini-css-extract-plugin
export default {"main":"LoadingSpinner_main__VoGpQ","loader":"LoadingSpinner_loader__UiPBi","l20-1":"LoadingSpinner_l20-1__jqIXZ","l20-2":"LoadingSpinner_l20-2__dkzTX"};